import { Controller } from "@hotwired/stimulus"

// Manages configurable signature blocks in the report type admin form.
// Supports up to maxBlocksValue blocks with per-block label, description, style, source
// (one fixed signature or one per person chosen in a field), required and show_signed_at.
// A new block is cloned from the server-rendered blockTemplate, so its markup and
// translations live in one partial (custom_report_types/editor/_signature_block).
export default class extends Controller {
  static targets = [
    "enabledToggle",
    "signatureList",
    "blocksContainer",
    "block",
    "addButton",
    "blockCountHint",
    "blockTemplate",
    "fieldPicker",
  ]

  static values = {
    maxBlocks: { type: Number, default: 3 },
    maxHint: String,
  }

  connect() {
    this.updateVisibility()
    this.updateAddButton()
  }

  toggleEnabled() {
    this.updateVisibility()
  }

  updateVisibility() {
    const enabled = this.enabledToggleTarget.checked
    if (enabled) {
      this.signatureListTarget.classList.remove("hidden")
    } else {
      this.signatureListTarget.classList.add("hidden")
    }
  }

  addBlock() {
    if (this.blockCount >= this.maxBlocksValue) return

    const key = `sig_${Date.now()}`
    const html = this.blockTemplateTarget.innerHTML.replaceAll("__KEY__", key)
    this.blocksContainerTarget.insertAdjacentHTML("beforeend", html)
    this.updateAddButton()
    this.notifyChange()
  }

  removeBlock(event) {
    const block = event.target.closest('[data-signature-config-target="block"]')
    if (block) {
      block.remove()
      this.updateAddButton()
      this.notifyChange()
    }
  }

  // The field picker only matters for a block that takes one signature per chosen person.
  toggleSource(event) {
    const block = event.target.closest('[data-signature-config-target="block"]')
    const picker = block?.querySelector('[data-signature-config-target="fieldPicker"]')
    if (picker) picker.classList.toggle("hidden", event.target.value !== "field")
  }

  // Adding or removing a block fires no input event; the settings card of the report type
  // editor needs one to see the draft.
  notifyChange() {
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }

  get blockCount() {
    return this.blockTargets.length
  }

  updateAddButton() {
    const atMax = this.blockCount >= this.maxBlocksValue
    this.addButtonTarget.disabled = atMax

    if (this.hasBlockCountHintTarget) {
      this.blockCountHintTarget.textContent = atMax ? this.maxHintValue : ""
    }
  }
}
